<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="book"
      inline
      class="px-5 py-3"
    >
      <template
        v-slot:after-heading
      >
        <div class="text-h2 font-weight-light">
          {{ $t('valitor') }} {{ $t('payment') }} #{{ entity.transaction_id }} | {{ entity.created_at }}
        </div>
      </template>
      <v-row class="justify-end">
        <v-btn
          color="coolrunner"
          @click="load(true)"
        >
          <v-icon class="mr-3">
            replay
          </v-icon>

          {{ $t('sync') }} {{ $t('valitor') }}
        </v-btn>
      </v-row>
      <v-container class="py-0">
        <v-row>
          <v-col
            cols="6"
          >
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('information')"
            >
              <v-data-iterator
                hide-default-footer
                dense
                :items="[information]"
              >
                <template v-slot:default="props">
                  <v-row>
                    <v-col
                      cols="12"
                    >
                      <v-list dense>
                        <template
                          v-for="(info, index) in information"
                        >
                          <v-list-item
                            v-if="info.val"
                            :key="index"
                            style="max-height: 30px; min-height: 30px;"
                          >
                            <v-list-item-content>
                              {{ info.title }}:
                            </v-list-item-content>
                            <v-list-item-content
                              class="align-end"
                            >
                              {{ info.val || '-' }}
                            </v-list-item-content>
                            <v-list-item-content
                              class="align-end"
                            >
                              <v-btn
                                v-if="info.copy"
                                v-clipboard:copy="info.val"
                                icon
                                small
                              >
                                {{ $t('copy') }}
                              </v-btn>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                      </v-list>
                    </v-col>
                  </v-row>
                </template>
              </v-data-iterator>
            </base-material-card>
          </v-col>
          <v-col
            cols="6"
          >
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('history')"
            >
              <v-list disabled>
                <v-list-item-group
                  color="primary"
                >
                  <v-list-item
                    v-for="(item, i) in entity.history"
                    :key="i"
                    dense
                  >
                    <v-list-item-content>
                      <v-list-item-title v-text="item.status" />
                      <v-list-item-subtitle v-text="item.created_at" />
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </base-material-card>
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('actions')"
            >
              <v-col cols="12">
                <v-subheader class="pl-0">
                  {{ $t('refund') }}
                </v-subheader>
                <v-row no-gutters>
                  <v-text-field
                    :value="refundAmount"
                    :disabled="locked || entity.balance_id || entity.vendor_information.balance === 0"
                    type="number"
                    min="0"
                    :max="(entity.vendor_information.balance || 0) / 100 || entity.amount"
                    step="0.01"
                    :placeholder="$t('amount')"
                    @keydown.enter="refund()"
                  />
                  <v-btn
                    color="coolrunner"
                    :disabled="locked || entity.balance_id || entity.vendor_information.balance === 0"
                    @click="refund"
                  >
                    {{ $t('refund') }}
                  </v-btn>
                </v-row>
                <v-subheader class="pl-0">
                  {{ $t('cancel') }}
                </v-subheader>
                <v-btn
                  color="coolrunner"
                  :disabled="locked || entity.balance_id || entity.vendor_information.balance === 0"
                  @click="cancel"
                >
                  {{ $t('cancel') }} {{ $t('payment') }}
                </v-btn>
              </v-col>
            </base-material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('shipments')"
            >
              <v-data-table
                :headers="shipmentHeaders"
                :items="shipments"
                dense
                class="elevation-0"
                hide-default-footer
              >
                <template v-slot:item.receiver="{ item }">
                  <template v-if="item.orderable && item.orderable.receiver">
                    {{ item.orderable.receiver.name }}, {{ item.orderable.receiver.street1 }} {{ item.orderable.receiver.street2 ? item.orderable.receiver.street2 +"," : "" }} {{ item.orderable.receiver.country }}-{{
                      item.orderable.receiver.zip_code
                    }},
                    {{ item.orderable.receiver.city }}
                  </template>
                </template>
                <template v-slot:item.insurance="{ item }">
                  {{ insuranceById(item.id) }}
                </template>
                <template v-slot:item.price="{ item }">
                  {{ item.sales_price_excl_vat.toFixed(2) }}/{{ item.sales_price_incl_vat.toFixed(2) }}
                </template>
                <template v-slot:item.action="{ item }">
                  <v-row justify="end">
                    <v-icon
                      medium
                      class="mr-5"
                      :disabled="!entity.vendor_information || entity.vendor_information.balance / 1000 < item.sales_price_incl_vat + (insuranceById(item.id) ? insuranceById(item.id).sales_price_incl_vat : 0)"
                      color="green"
                      @click="refundShipment(item, insuranceById(item.id))"
                    >
                      replay
                    </v-icon>
                    <v-btn
                      target="_blank"
                      icon
                      :href="labelUrl(item)"
                    >
                      <v-icon
                        medium
                        class="mr-5"

                        color="green"
                      >
                        picture_as_pdf
                      </v-icon>
                    </v-btn>
                    <v-btn
                      v-if="item.orderable && item.orderable.receiver"
                      target="_blank"
                      icon
                      :href="`https://www.google.dk/maps/search/${item.orderable.receiver.street1},+${item.orderable.receiver.country}-${item.orderable.receiver.zip_code},+${item.orderable.receiver.city}/`"
                    >
                      <v-icon
                        medium
                        class="mr-5"

                        color="green"
                      >
                        place
                      </v-icon>
                    </v-btn>
                  </v-row>
                </template>
              </v-data-table>
            </base-material-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="6">
            <base-material-card
              color="coolrunner"
              inline
              class="px-5 py-3"
              :title="$t('vendor_data')"
            >
              <v-row class="justify-end">
                <v-btn
                  v-clipboard:copy="JSON.stringify(entity.vendor_information, null, 4)"
                  color="green"
                  class="ml-auto"
                >
                  {{ $t( 'copy') }}
                </v-btn>
              </v-row>
              <v-textarea
                disabled
                :rows="JSON.stringify(entity.vendor_information, null, 4).split(/[\r\n]/).length"
                :value="JSON.stringify(entity.vendor_information, null, 4)"
              />
            </base-material-card>
          </v-col>
        </v-row>
      </v-container>
    </base-material-card>
    <base-loading-overlay :loading="loading" />
  </v-container>
</template>
<script>
  import { URL_PREFIX } from '@/utils/constants'
  import { handleErrorResponse } from '@/plugins/data'

  import Edit from '@/mixins/Edit'

  export default {
    mixins: [Edit],
    data () {
      return {
        endpoint: 'payments/valitor',
        name: 'payment',
        params: {
          with: ['order.orderLines.orderable'],
        },
        entity: { vendor_information: { CreditCardExpiry: {} } },
        locked: false,
        refundAmount: null,
        shipmentHeaders: [
          {
            sortable: false,
            text: this.$t('product'),
            value: 'orderable.title',
          },
          {
            sortable: false,
            text: this.$t('package_number'),
            value: 'orderable.package_number',
          },
          {
            sortable: false,
            text: this.$t('labelless'),
            value: 'orderable.labelless_code',
          },
          {
            sortable: false,
            text: this.$t('receiver'),
            value: 'receiver',
          },
          {
            sortable: false,
            text: this.$t('insurance'),
            value: 'insurance',
          },
          {
            sortable: false,
            text: this.$t('price'),
            value: 'price',
          },
          { text: this.$t('actions'), value: 'action', sortable: false },

        ],
      }
    },
    computed: {
      vendor_information: function () {
        if (this.entity.vendor_information && !this.entity.vendor_information.message) { return this.entity.vendor_information }

        return {
          CreditCardExpiry: {},
          balance: null,
        }
      },
      information: function () {
        return {
          transaction_id: { title: this.$t('transaction_id'), val: this.entity.transaction_id, copy: true },
          subscription: { title: this.$t('subscription'), val: this.entity.subscription && this.entity.subscription.subscription_id, copy: true },
          customer_id: { title: this.$t('customer_id'), val: this.getCustomerId(), copy: true },
          order: { title: this.$t('order'), val: this.entity.order && this.entity.order.id, copy: true },
          amount: { title: this.$t('amount'), val: this.entity.amount && `${this.entity.currency || ''} ${(this.entity.amount).toFixed(2)},-` },
          qp_balance: { title: this.$t('qp_balance'), val: this.vendor_information.balance && `${this.entity.currency || ''} ${(this.vendor_information.balance / 100).toFixed(2)},-` },
          card_type: { title: this.$t('card_type'), val: this.vendor_information.PaymentSchemeName },
          card_number: { title: this.$t('card_number'), val: this.formatCard(this.entity.card_number) },
          expired: { title: this.$t('expired'), val: `${this.vendor_information.CreditCardExpiry.Month + ''}/${this.vendor_information.CreditCardExpiry.Year + ''.substr(2, 2)}` },
          saldo_payment: { title: this.$t('saldo_payment'), val: `${this.entity.balance_id ? this.$t('yes') : this.$t('no')}` },
        }
      },
      shipments: function () {
        if (!this.entity.order) { return [] }

        return this.$_.filter(this.entity.order.order_lines, ['orderable_type', 'shipment'])
      },
      insurances: function () {
        if (!this.entity.order) { return [] }

        return this.$_.filter(this.entity.order.order_lines, ['orderable_type', 'insurance'])
      },
    },
    methods: {
      load (refresh) {
        if (!this.$route.params || !this.canRead()) { return }

        this.loading = true
        this.$get(`${this.endpoint}/${this.$route.params.id}`, { ...this.params, refresh: refresh })
          .then(response => {
            this.entity = response.data

            this.loading = false

            refresh && this.$toast(`${this.$t('payment')} ${this.$t('synced')}`)
          })
          .catch(() => {
            refresh && this.$toast(`${this.$t('payment')} ${this.$t('not')} ${this.$t('synced')}`)

            this.loading = false
          })
      },
      insuranceById: function (id) {
        return this.$_.find(this.insurances, ['id', id]) || this.$t('no')
      },
      getCustomerId: function () {
        const possibilities = [
          this.entity.order ? this.entity.order.customer_id : false,
          this.entity.subscription ? this.entity.subscription.customer_id : false,
        ].filter(e => e !== false)

        return possibilities.length ? possibilities[0] : false
      },
      formatQpDate (date) {
        return this.$moment(date).format('YYYY-MM-DD HH:mm:ss')
      },
      formatCard (card) {
        return card ? card.match(/.{4}/g).join(' ') : ''
      },
      labelUrl: function (orderLine) {
        return `${URL_PREFIX}/panel/shippinglabels/${orderLine.orderable.package_number}/label`
      },
      refund: function () {
        if (this.locked) { return false }

        this.locked = true
        const refundAmount = parseFloat(this.refundAmount)
        if (
          refundAmount > this.entity.vendor_information.balance / 100 ||
          !this.form.refundAmount ||
          refundAmount <= 0
        ) {
          this.locked = false

          this.$toast(`${this.$t('entry_error')} ${this.$t('amount')} ${this.$t(!this.refundAmount ? 'too_low' : 'too_high')}`, { color: 'red' })
          return
        }

        if (confirm(`${this.$t('confirm_cancellation')} ${refundAmount.toFixed(2)},- ?`)) {
          this.loading = true
          this.$patch(`${this.endpoint}/${this.$route.params.id}`, {
              action: 'refund',
              amount: this.refundAmount,
            })
            .then(({ data }) => {
              this.refundAmount = 0
              data.success
                ? this.$toast(data.message || this.$t('action_succeeded'))
                : handleErrorResponse(data.message || this.$t('action_failed'))

              this.load(true)
            })
            .catch(e => {
              this.locked = false
              return Promise.reject(e)
            })
            .catch(handleErrorResponse)
        }
      },
      cancel: function () {
        if (this.locked) { return false }

        this.locked = true

        if (confirm(`${this.$t('confirm_cancellation')} ${this.$t('payment')}`)) {
          this.loading = true
          const params = {
            with: ['balance', 'order'],
          }
          this.$patch(`${this.endpoint}/${this.$route.params.id}`, params, {
              action: 'cancel',
            })
            .then(({ data }) => {
              data.success
                ? this.$toast(data.message || this.$t('action_succeeded'))
                : handleErrorResponse(data.message || this.$t('action_failed'))

              this.load(true)
              this.locked = false
            })
            .catch(e => {
              this.locked = false
              return Promise.reject(e)
            })
            .catch(handleErrorResponse)
        }
      },
      refundShipment: function (orderLine, insurance) {
        this.refundAmount = (orderLine.sales_price_incl_vat + (insurance ? insurance.sales_price_incl_vat : 0)).toFixed(2)

        this.refund()
      },
    },
  }
</script>
<style scoped>
.v-data-iterator .v-card {
  box-shadow: initial;
}
</style>
